<template>
  <div id="SaleDesc">
    <TopNav />
    <LeftNav />
    <mu-container fluid class="main_content" :style="{ marginLeft: !$store.state.menuExpand ? '288px' : '112px' }">
      <mu-row>
        <mu-col :span="12">
          <mu-flex direction="column">
            <Breadcrumbs :navIcon="'build'" :title="{ name: this.$t('saleAdmin.title') }" :subTitles="[
              { name: this.$t('saleAdmin.title'), url: '/saleAdmin' },
              { name: this.$t('saleAdmin.saleDesc') },
            ]"></Breadcrumbs>
            <mu-paper class="custom-paper" style="margin-top:24px;">
              <mu-flex direction="column">
                <mu-row style="width:100%;margin-bottom:16px;">
                  <mu-col :span="3">
                    <p class="item_cls">{{ $t('saleAdmin.userName') }}：<span>{{ saleOrder.userName }}</span></p>
                  </mu-col>
                  <mu-col :span="3">
                    <p class="item_cls">{{ $t('saleAdmin.companyName') }}：<span>{{ saleOrder.companyName }}</span></p>
                  </mu-col>
                  <mu-col :span="1" :offset="2">
                    <mu-badge :content="$t('saleAdmin.status_submission')" color="grey500"
                      v-if="saleOrder.status == 0"></mu-badge>
                    <mu-badge :content="$t('saleAdmin.status_modify')" color="info"
                      v-if="saleOrder.status == 1"></mu-badge>
                    <mu-badge :content="$t('saleAdmin.status_complete')" color="success"
                      v-if="saleOrder.status == 2"></mu-badge>
                    <mu-badge :content="$t('saleAdmin.deviceQuotation')" color="primary"
                      v-if="saleOrder.status == 3"></mu-badge>
                    <mu-badge content="维修测试" color="primary" v-if="saleOrder.status == 4"></mu-badge>
                    <mu-badge :content="$t('saleAdmin.status_reject')" color="secondary"
                      v-if="saleOrder.status == -1"></mu-badge>
                  </mu-col>
                </mu-row>
                <mu-row style="width:100%;margin-bottom:16px;">
                  <mu-col :span="3">
                    <p class="item_cls">{{ $t('saleAdmin.telephone') }}：<span>{{ saleOrder.telephone }}</span></p>
                  </mu-col>
                  <mu-col :span="3">
                    <p class="item_cls">{{ $t('saleAdmin.createTime') }}：<span>{{ saleOrder.createTime | datetime }}</span>
                    </p>
                  </mu-col>
                </mu-row>
                <mu-row style="width:100%;margin-bottom:16px;">
                  <mu-col :span="3">
                    <p class="item_cls">{{ $t('saleAdmin.orderNumber') }}：<span>{{ saleOrder.serialNumber == null ?
                      $t('saleAdmin.noSingleNumber') : saleOrder.serialNumber }}</span></p>
                  </mu-col>
                  <mu-col :span="3">
                    <p class="item_cls">{{ $t('saleAdmin.address') }}：<span>{{ saleOrder.address }}</span></p>
                  </mu-col>
                  <mu-col :span="6">
                    <p class="item_cls">{{ $t('saleAdmin.descAddress') }}：<span>{{ saleOrder.descAddress }}</span></p>
                  </mu-col>
                </mu-row>
                <mu-row style="width:100%;margin-bottom:16px;">
                  <mu-col>
                    <p class="item_cls">{{ $t('saleAdmin.deviceAccessories') }}：<span>{{ saleOrder.accessories == null ?
                      $t('saleAdmin.noneAccessories') : saleOrder.accessories }}</span></p>
                  </mu-col>
                </mu-row>
                <mu-row style="width:100%;margin-bottom:16px;">
                  <mu-col :span="4">
                    <p class="item_cls">{{ $t('saleAdmin.receiveExpressNum') }}：<span>{{ saleOrder.sendNum }}</span></p>
                  </mu-col>
                  <mu-col :span="4">
                    <p class="item_cls">
                      {{ $t('saleAdmin.receiveExpressCompany') }}：<span>{{ saleOrder.sendExpressName }}</span></p>
                  </mu-col>
                </mu-row>
                <!--                  发回快递信息-->
                <div style="width: 100%" v-if="saleOrder.receiveNum != null">
                  <h3 class="title">{{ $t('saleAdmin.logisticsSsend') }}</h3>
                  <!--                    <mu-row style="width:100%;margin-bottom:16px;">-->
                  <!--                      <mu-col :span="4">-->
                  <!--                        <p class="item_cls">{{$t('saleAdmin.sendExpressNum')}}：<span>{{saleOrder.receiveNum}}</span></p>-->
                  <!--                      </mu-col>-->
                  <!--                      <mu-col :span="4">-->
                  <!--                        <p class="item_cls">{{$t('saleAdmin.sendExpressCompany')}}：<span>{{saleOrder.receiveExpressName}}</span></p>-->
                  <!--                      </mu-col>-->
                  <!--                    </mu-row>-->
                  <mu-flex justify-content="between" align-items="center" style="width:100%;margin-top:8px;">
                    <p>{{ $t('saleAdmin.sendExpressNum') }}：<span>{{ saleOrder.receiveNum }}</span></p>
                    <mu-badge color="grey500" content="在途" v-if="receiveExpressInfo.state == 0"></mu-badge>
                    <mu-badge color="grey500" content="揽收" v-if="receiveExpressInfo.state == 1"></mu-badge>
                    <mu-badge color="secondary" content="疑难" v-if="receiveExpressInfo.state == 2"></mu-badge>
                    <mu-badge color="success" content="签收" v-if="receiveExpressInfo.state == 3"></mu-badge>
                    <mu-badge color="secondary" content="退签" v-if="receiveExpressInfo.state == 4"></mu-badge>
                    <mu-badge color="grey500" content="派件" v-if="receiveExpressInfo.state == 5"></mu-badge>
                    <mu-badge color="grey500" content="退回" v-if="receiveExpressInfo.state == 6"></mu-badge>
                    <mu-badge color="grey500" content="转单" v-if="receiveExpressInfo.state == 7"></mu-badge>
                    <mu-badge color="grey500" content="待清关" v-if="receiveExpressInfo.state == 10"></mu-badge>
                    <mu-badge color="grey500" content="清关中" v-if="receiveExpressInfo.state == 11"></mu-badge>
                    <mu-badge color="success" content="已清关" v-if="receiveExpressInfo.state == 12"></mu-badge>
                    <mu-badge color="secondary" content="清关异常" v-if="receiveExpressInfo.state == 13"></mu-badge>
                    <mu-badge color="secondary" content="拒签" v-if="receiveExpressInfo.state == 14"></mu-badge>
                  </mu-flex>
                  <p>{{ $t('saleAdmin.sendExpressCompany') }}：<span>{{ saleOrder.receiveExpressName }}</span></p>
                  <p v-if="receiveExpressInfo.data && receiveExpressInfo.data.length > 0">
                    {{ $t('saleAdmin.currentState') }}<span>{{ receiveExpressInfo.data[0].context }}</span></p>
                  <p v-if="receiveExpressInfo.data && receiveExpressInfo.data.length > 0">
                    {{ $t('saleAdmin.updateTime') }}<span>{{ receiveExpressInfo.data[0].ftime }}</span></p>
                </div>
                <!--                  无报价设备维修完成  -->
                <div v-if="this.saleOrder.receiveNum != null" style="width: 100%">
                  <!--                  无报价设备隐藏-->
                  <mu-row gutter style="width:100%;border-top:1px solid #eee;">
                    <mu-col span="12">
                      <p>
                        {{ $t('saleAdmin.maintenanceDevice') }}
                      </p>
                    </mu-col>
                    <mu-col :span="6" v-for="device in deviceList" :key="device.id">
                      <el-card :class="device.id" class="box-card">
                        <mu-flex justify-content="between" align-items="center" style="width:100%;">
                          <p class="item_cls">{{ $t('saleAdmin.lengthWarranty') }}：<span>{{ device.warrantyTime }}</span></p>
                          <mu-badge :content="$t('saleAdmin.warrantyPeriod')" color="success"
                            v-if="device.warrantyStatus == 1"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.warrantyExpired')" color="error"
                            v-if="device.warrantyStatus == 0"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.warrantyPeriodUnknown')" color="error"
                            v-if="device.warrantyStatus == 9"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.warrantyPeriodUnknown')" color="error"
                            v-if="device.warrantyStatus == null"></mu-badge>
                        </mu-flex>
                        <p class="item_cls" v-if="device.imei != null && device.sn.length > 0">
                          {{ $t('saleAdmin.deviceIMEI') }}：<span>{{ device.imei }}</span></p>
                        <p class="item_cls" v-if="device.sn != null && device.sn.length > 0">
                          {{ $t('saleAdmin.deviceSN') }}：<span>{{ device.sn }}</span></p>
                        <p class="item_cls" v-if="device.type != null && device.type.length > 0">
                          {{ $t('saleAdmin.deviceType') }}：<span>{{ device.type }}</span></p>
                        <p class="item_cls">{{ $t('saleAdmin.problemReason') }}：<span>{{ device.problemReason }}</span></p>
                        <el-button @click="openHistory(device.imei, device.sn)"
                          size="mini">{{ $t('saleAdmin.viewTheMaintenanceHistory') }}</el-button>
                        <el-button @click="openDeviceError(device)" size="mini"
                          type="primary">{{ $t('saleAdmin.fillInTroubleInformation') }}</el-button>
                      </el-card>
                    </mu-col>
                  </mu-row>
                </div>
                <!--                  维修中设备和等待报价付款设备  -->
                <div v-if="this.saleOffer != null" style="width: 100%">
                  <!--                  无报价设备隐藏-->
                  <mu-row gutter style="width:100%;border-top:1px solid #eee;">
                    <mu-col span="12">
                      <mu-flex justify-content="between" align-items="center" align-self="stretch"
                        style="padding-top:8px;padding-bottom:8px;">
                        <mu-flex align-items="center">
                          <span style="margin-right:4px;">报价设备</span>
                          <mu-badge :content="$t('saleAdmin.notPaying')" color="grey500"
                            v-if="saleOffer.status == 0"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.paymentToBeConfirmed')" color="warning"
                            v-if="saleOffer.status == 1"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.confirmedPayment')" color="success"
                            v-if="saleOffer.status == 2"></mu-badge>
                        </mu-flex>
                        <mu-flex align-items="center" justify-content="end" align-self="stretch">
                          <!--                          <mu-button flat samll to="this.saleOffer.s3url" @click="downloadExcel" color="primary">-->
                          <!--                            <mu-icon value="file_download" left></mu-icon>-->
                          <a :href="this.saleOffer.s3url" download
                            target="_blank">{{ $t('saleAdmin.downloadMaintenanceQuotation') }}</a>
                          <!--                          </mu-button>-->
                          <el-button @click="changePaymentStatus" style="float: right;margin-right: 20px"
                            v-if="saleOffer.status != 2">
                            {{ $t('saleAdmin.confirmedPay') }}
                          </el-button>
                        </mu-flex>
                      </mu-flex>
                    </mu-col>
                    <mu-col v-for="device in submittedOfferDevice" :key="device.id" span="6">
                      <el-card :class="device.id" class="box-card">
                        <mu-flex justify-content="between" align-items="center" style="width:100%;">
                          <p class="item_cls">{{ $t('saleAdmin.lengthWarranty') }}：<span>{{ device.warrantyTime }}</span></p>
                          <mu-badge :content="$t('saleAdmin.warrantyPeriod')" color="success"
                            v-if="device.warrantyStatus == 1"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.warrantyExpired')" color="error"
                            v-if="device.warrantyStatus == 0"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.warrantyPeriodUnknown')" color="error"
                            v-if="device.warrantyStatus == 9"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.warrantyPeriodUnknown')" color="error"
                            v-if="device.warrantyStatus == null"></mu-badge>
                        </mu-flex>
                        <p class="item_cls" v-if="device.imei != null && device.imei.length > 0">
                          {{ $t('saleAdmin.deviceIMEI') }}：<span>{{ device.imei }}</span></p>
                        <p class="item_cls" v-if="device.sn != null && device.sn.length > 0">
                          {{ $t('saleAdmin.deviceSN') }}：<span>{{ device.sn }}</span></p>
                        <p class="item_cls" v-if="device.type != null && device.type.length > 0">
                          {{ $t('saleAdmin.deviceType') }}：<span>{{ device.type }}</span></p>
                        <p class="item_cls">{{ $t('saleAdmin.problemReason') }}：<span>{{ device.problemReason }}</span></p>
                        <el-button @click="openHistory(device.imei, device.sn)"
                          size="mini">{{ $t('saleAdmin.viewTheMaintenanceHistory') }}</el-button>
                        <el-button @click="openDeviceError(device)" size="mini"
                          type="primary">{{ $t('saleAdmin.fillInTroubleInformation') }}</el-button>
                      </el-card>
                    </mu-col>
                  </mu-row>
                  <mu-row gutter style="width:100%;border-top:1px solid #eee;"
                    v-if="deviceList.length > 0 && this.saleOrder.receiveNum == null">
                    <mu-col span="12">
                      <p>
                        {{ $t('saleAdmin.In-serviceDevice') }}
                      </p>
                    </mu-col>
                    <mu-col :span="6" v-for="device in deviceList" :key="device.id">
                      <el-card :class="device.id" class="box-card">
                        <mu-flex justify-content="between" align-items="center" style="width:100%;">
                          <p class="item_cls">{{ $t('saleAdmin.lengthWarranty') }}：<span>{{ device.warrantyTime }}</span></p>
                          <mu-badge :content="$t('saleAdmin.warrantyPeriod')" color="success"
                            v-if="device.warrantyStatus == 1"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.warrantyExpired')" color="error"
                            v-if="device.warrantyStatus == 0"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.warrantyPeriodUnknown')" color="error"
                            v-if="device.warrantyStatus == 9"></mu-badge>
                          <mu-badge :content="$t('saleAdmin.warrantyPeriodUnknown')" color="error"
                            v-if="device.warrantyStatus == null"></mu-badge>
                        </mu-flex>
                        <p class="item_cls" v-if="device.imei != null && device.sn.length > 0">
                          {{ $t('saleAdmin.deviceIMEI') }}：<span>{{ device.imei }}</span></p>
                        <p class="item_cls" v-if="device.sn != null && device.sn.length > 0">
                          {{ $t('saleAdmin.deviceSN') }}：<span>{{ device.sn }}</span></p>
                        <p class="item_cls" v-if="device.type != null && device.type.length > 0">
                          {{ $t('saleAdmin.deviceType') }}：<span>{{ device.type }}</span></p>
                        <p class="item_cls">{{ $t('saleAdmin.problemReason') }}：<span>{{ device.problemReason }}</span></p>
                        <el-button @click="openHistory(device.imei, device.sn)"
                          size="mini">{{ $t('saleAdmin.viewTheMaintenanceHistory') }}</el-button>
                        <el-button @click="openDeviceError(device)" size="mini"
                          type="primary">{{ $t('saleAdmin.fillInTroubleInformation') }}</el-button>
                      </el-card>
                    </mu-col>
                  </mu-row>
                </div>

                <!--                  初始化显示    报价或者维修完成后隐藏-->
                <mu-row v-if="this.saleOffer == null && saleOrder.status != 2" gutter
                  style="width:100%;border-top:1px solid #eee;">
                  <mu-col v-if="this.offerDevice.length <= 0" span="12">
                    <div>
                      <p>
                        {{ $t('saleAdmin.selectEquipmentToQuote') }}
                      </p>
                    </div>
                  </mu-col>
                  <mu-col v-if="this.offerDevice.length > 0" span="12">
                    <mu-flex align-items="center" justify-content="end" align-self="stretch" style="margin:8px">
                      <el-upload class="upload-demo" ref="upload" action :http-request="Upload" :on-remove="handleRemove"
                        :on-change="uploadChange" :on-success="uploadSuccess" :on-exceed="onFileExceed"
                        :file-list="fileList" :auto-upload="false">
                        <el-button slot="trigger" size="small"
                          type="primary">{{ $t('saleAdmin.uploadQuotation') }}</el-button>
                      </el-upload>
                    </mu-flex>
                  </mu-col>
                  <mu-col :span="6" v-for="device in deviceList" :key="device.id">
                    <el-card :class="device.id" class="box-card">
                      <mu-flex justify-content="between" align-items="center" style="width:100%;">
                        <p v-if="device.warrantyTime != null" class="item_cls">
                          {{ $t('saleAdmin.lengthWarranty') }}：<span>{{ device.warrantyTime }}</span></p>
                        <p v-if="device.warrantyTime == null" class="item_cls">
                          {{ $t('saleAdmin.lengthWarranty') }}：<span>{{ $t("saleAdmin.unknown") }}</span></p>
                        <mu-badge :content="$t('saleAdmin.warrantyPeriod')" color="success"
                          v-if="device.warrantyStatus == 1"></mu-badge>
                        <mu-badge :content="$t('saleAdmin.warrantyExpired')" color="error"
                          v-if="device.warrantyStatus == 0"></mu-badge>
                        <mu-badge :content="$t('saleAdmin.warrantyPeriodUnknown')" color="error"
                          v-if="device.warrantyStatus == 9"></mu-badge>
                        <mu-badge :content="$t('saleAdmin.warrantyPeriodUnknown')" color="error"
                          v-if="device.warrantyStatus == null"></mu-badge>

                      </mu-flex>
                      <mu-checkbox @click="addOfferDevice(device.id)" style="float: right;margin: 10px 0px;"
                        color="yellow700" v-model="selects" :value="device.id" uncheck-icon="star_border"
                        checked-icon="star"></mu-checkbox>
                      <p class="item_cls" v-if="device.imei != null && device.sn.length > 0">
                        {{ $t('saleAdmin.deviceIMEI') }}：<span>{{ device.imei }}</span></p>
                      <p class="item_cls" v-if="device.sn != null && device.sn.length > 0">
                        {{ $t('saleAdmin.deviceSN') }}：<span>{{ device.sn }}</span></p>
                      <p class="item_cls" v-if="device.type != null && device.type.length > 0">
                        {{ $t('saleAdmin.deviceType') }}：<span>{{ device.type }}</span></p>
                      <p class="item_cls">{{ $t('saleAdmin.problemReason') }}：<span>{{ device.problemReason }}</span></p>
                      <el-button @click="openHistory(device.imei, device.sn)"
                        size="mini">{{ $t('saleAdmin.viewTheMaintenanceHistory') }}</el-button>
                      <el-button @click="openDeviceError(device)" size="mini"
                        type="primary">{{ $t('saleAdmin.fillInTroubleInformation') }}</el-button>
                    </el-card>
                  </mu-col>
                </mu-row>
              </mu-flex>
            </mu-paper>
            <mu-paper v-if="saleOrder.status != 2" class="custom-paper" style="margin-top:24px;">
              <el-form :model="updateOrder" ref="form" label-width="120px" :rules="rules">
                <el-form-item :label="$t('saleAdmin.status')" prop="status">
                  <el-radio-group v-model="updateOrder.status" size="small">
                    <el-radio-button v-if="saleOffer == null || saleOffer.status != 2"
                      :label="1">{{ $t('saleAdmin.status_modify') }}</el-radio-button>
                    <el-radio-button v-if="this.saleOffer == null"
                      :label="3">{{ $t('saleAdmin.status_offer') }}</el-radio-button>
                    <el-radio-button :label="4">维修测试</el-radio-button>
                    <el-radio-button :label="2">{{ $t('saleAdmin.status_complete') }}</el-radio-button>
                    <el-radio-button :label="-1">{{ $t('saleAdmin.status_reject') }}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-row :gutter="24" v-if="updateOrder.status == 2">
                  <el-col :span="10">
                    <el-form-item :label="$t('saleAdmin.receiveExpressCompany')" prop="receiveExpressCode">
                      <el-select filterable v-model="updateOrder.receiveExpressCode" style="width:100%;">
                        <el-option v-for="express in expressList" :key="express.code" :value="express.code"
                          :label="express.name"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item :label="$t('saleAdmin.receiveExpressNum')" prop="receiveNum">
                      <el-input v-model="updateOrder.receiveNum"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24" v-if="updateOrder.status == -1">
                  <el-col :span="16">
                    <el-form-item :label="$t('saleAdmin.remark')" prop="remark">
                      <el-input type="textarea" :rows="4" :placeholder="$t('saleAdmin.rejectReason')"
                        v-model="updateOrder.remark"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <mu-flex v-if="updateOrder.status == 3" justify-content="center" align-items="center" style="width:100%;">
                <mu-button color="primary" @click="offerSubmit" :disabled="updateOrder.status == 0"
                  v-loading="updateLoading">
                  {{ $t('button.submit') }}
                </mu-button>
              </mu-flex>
              <mu-flex v-else justify-content="center" align-items="center" style="width:100%;">
                <mu-button color="primary" @click="onSubmit" :disabled="updateOrder.status == 0"
                  v-loading="updateLoading">
                  {{ $t('button.submit') }}
                </mu-button>
              </mu-flex>
            </mu-paper>
          </mu-flex>
        </mu-col>
      </mu-row>
    </mu-container>
    <!-- 历史维修记录 -->
    <el-dialog width="890px" :close-on-click-modal="false" :title="$t('saleAdmin.HistoricalMaintenanceRecords')"
      :visible.sync="HisListFlag">
      <el-table :data="tableData" class="custom_el_table" height="420" :empty-text="$t('common.emptyText')"
        v-loading="tableLoading">
        <el-table-column align="center" prop="imei" :label="$t('device.equipmentImei')" width="180">
          <template slot-scope="scope">{{ scope.row.imei == null || scope.row.imei == "" ? $t('common.emptyText') :
            scope.row.imei }}</template>
        </el-table-column>
        <el-table-column align="center" prop="sn" :label="$t('saleAdmin.deviceSN')" width="180">
          <template slot-scope="scope">{{ scope.row.sn == null || scope.row.sn == "" ? $t('common.emptyText') :
            scope.row.sn }}</template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" :label="$t('saleAdmin.MaintenanceTime')">
          <template slot-scope="scope">{{ scope.row.createTime | datetime }}</template>
        </el-table-column>
        <el-table-column align="center" prop="problemReason" :label="$t('saleAdmin.FaultDescription')"></el-table-column>
      </el-table>
      <Pagination :current="current" :changePage="getHistory" style="width: 100%;margin-top:28px;" />
    </el-dialog>
    <!-- 设备故障信息 -->
    <el-dialog width="890px" :close-on-click-modal="false" :title="$t('saleAdmin.deviceFaultInformation')"
      :visible.sync="deviceErrorDlgFLg">
      <el-form ref="devceErrorForm" :model="deviceErrorModel" label-width="120px" :rules="deviceErrorRules">
        <el-row gutter>
          <el-col :span="12">
            <el-form-item :label="$t('saleAdmin.FaultClassification')" prop="faultClass">
              <!--              <el-input v-model="deviceErrorModel.faultClass" size="small"></el-input>-->
              <el-select :disabled="saleOrder.status == 2" v-model="deviceErrorModel.faultClass"
                :placeholder="$t('saleAdmin.Pleaseselectfaultclassification')" @change="changeFaultClass" size="small">
                <el-option :label="$t('saleAdmin.hardwareFailure')" value="015"></el-option>
                <el-option :label="$t('saleAdmin.softwareFailures')" value="016"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('saleAdmin.detailedClassification')" prop="faultClassification">
              <el-input :disabled="saleOrder.status == 2" v-model="deviceErrorModel.faultClassification"
                size="small"></el-input>
              <!--              <el-select v-model="deviceErrorModel.faultClassification" :placeholder="$t('saleAdmin.Pleaseselectcategorydetails')" size="small">-->
              <!--                <el-option v-for="option in classificationList" :key="option.code" :label="option.name" :value="option.name"></el-option>-->
              <!--              </el-select>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('saleAdmin.faultDetails')">
          <el-input :disabled="saleOrder.status == 2" type="textarea" v-model="deviceErrorModel.faultDetails"
            size="small"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="deviceErrorDlgFLg = false">{{ $t('button.close') }}</el-button>
          <el-button :disabled="saleOrder.status == 2" type="primary"
            @click="submitDeviceError">{{ $t('button.confirm') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import TopNav from "@/components/TopNav";
import LeftNav from "@/components/LeftNav";
import Breadcrumbs from "@/components/Breadcrumbs";
import * as API from "@/api/saleAdmin";
import * as API_DICTIONARY from '@/api/system/Dictionary'
import Utils from "@/utils/utils";
import { uploadTemp } from "../../fs"

export default {
  name: "SaleDesc",
  data() {
    return {
      tableLoading: false,
      HisListFlag: false,
      HisSearch: {
        imei: null,
        sn: null
      },
      current: {
        pageSize: 10,
        page: 1,
        totalSize: 0
      },
      tableData: [],
      receiveExpressInfo: null,
      saleOffer: {},
      //已提交的报价设备
      submittedOfferDevice: [],
      isFile: false,
      fileList: [],
      //提交的报价设备
      offerDevice: [],
      currentId: null,
      selects: [],
      saleOrder: {},
      deviceList: [],
      offerExcelUrl: null,
      updateOrder: {
        status: 0,
        receiveNum: null,
        receiveExpressCode: null,
        remark: null
      },
      expressList: [],
      updateLoading: false,
      rules: {
        status: [{
          required: true,
          message: this.$t('common.must'),
          trigger: ['blur', 'change']
        }],
        receiveExpressCode: [{
          required: true,
          message: this.$t('common.must'),
          trigger: ['blur', 'change']
        }],
        receiveNum: [{
          required: true,
          message: this.$t('common.must'),
          trigger: ['blur', 'change']
        }],
        remark: [{
          required: true,
          message: this.$t('common.must'),
          trigger: ['blur', 'change']
        }]
      },
      deviceErrorModel: {},
      deviceErrorDlgFLg: false,
      classificationList: [],
      deviceErrorRules: {
        faultClass: [
          { required: true, message: this.$t("check.notBlack"), trigger: ["blur", "change"] }
        ],
        faultClassification: [
          { required: true, message: this.$t("check.notBlack"), trigger: ["blur", "change"] }
        ],
      }
    }
  },
  watch: {
    offerDevice() {
      if (this.offerDevice.length > 0) {
        this.updateOrder.status = 3;
      } else {
        this.updateOrder.status = 1;
        this.isFile = false;
      }
    },
    'updateOrder.status': {
      handler: function () {
        // if(this.updateOrder.status != -1){
        //   this.updateOrder.remark = null;
        // }
        if (this.updateOrder.status != 2) {
          this.updateOrder.receiveExpressCode = null;
          this.updateOrder.receiveNum = null;
        }
      }
    }
  },
  mounted() {
    this.currentId = this.$route.params.id;
    this.getOrderDesc();
    API.getExpressList({ type: 0 }).then(res => {
      console.log(res);
      this.expressList = res;
    });
  },
  components: { TopNav, LeftNav, Breadcrumbs },
  methods: {
    getOrderDesc() {
      API.select({ id: this.currentId }).then(res => {
        // console.log(res);
        if (res.code == 200) {
          console.log(res)
          this.saleOrder = res.data.saleOrder;
          this.updateOrder.remark = res.data.saleOrder.remark;
          this.deviceList = res.data.saleOrderDevicesList;
          this.submittedOfferDevice = res.data.saleOfferDeviceList;
          this.saleOffer = res.data.saleOffer
          // console.log(this.deviceList)
          this.updateOrder.status = this.saleOrder.status;
          //分析是否超出保质期
          var deviceLifeCycleList = [];
          deviceLifeCycleList = res.data.deviceLifeCycleList;
          //一年的毫秒数
          var mils = (1000 * 60 * 60 * 24 * 365);
          //创建订单的时间
          var createTime = new Date(this.saleOrder.createTime).getTime();
          console.log(this.deviceList);
          console.log(this.submittedOfferDevice)
          for (var i = 0; i < deviceLifeCycleList.length; i++) {
            var warranty = "";
            if (deviceLifeCycleList[i].warrantyPeriod != null && deviceLifeCycleList[i].warrantyPeriod != "9999年") {
              warranty = deviceLifeCycleList[i].warrantyPeriod;
              warranty = warranty.substring(0, 1);
            }
            //等于9代表保修期未知
            if (deviceLifeCycleList[i].warrantyPeriod == null || deviceLifeCycleList[i].warrantyPeriod == "9999年") {
              warranty = 9;
            }
            if (warranty == "一") {
              warranty = 1;
            }
            if (warranty == "二") {
              warranty = 2;
            }
            if (warranty == "三") {
              warranty = 3;
            }
            var shipMent = 0;
            if (deviceLifeCycleList[i].shipmentTime != null) {
              shipMent = Utils.insertStr(Utils.insertStr(deviceLifeCycleList[i].shipmentTime, 4, "/"), 7, "/");
              shipMent = new Date(shipMent).getTime();
            }
            //创建订单的时间减去出货时间
            // debugger;
            var retDate = createTime - shipMent;
            //判断是否在一年保修期内,小于说明在
            if (this.deviceList != null) {
              for (var j = 0; j < this.deviceList.length; j++) {
                if (this.deviceList[j].imei == deviceLifeCycleList[i].imei) {
                  if (warranty == 9) {
                    this.deviceList[j].warrantyStatus = 9;
                    this.deviceList[j].warrantyTime = this.$t('saleAdmin.unknown');
                  } else {
                    if (retDate < (mils * warranty)) {
                      this.deviceList[j].warrantyStatus = 1;
                      this.deviceList[j].warrantyTime = warranty + this.$t('saleAdmin.years');
                    } else {
                      this.deviceList[j].warrantyStatus = 0;
                      this.deviceList[j].warrantyTime = warranty + this.$t('saleAdmin.years');
                    }
                  }
                }
                // if(this.deviceList[j].sn == deviceLifeCycleList[i].sn){
                //   if(retDate<(mils*warranty)){
                //     this.deviceList[j].warrantyStatus = 1;
                //     this.deviceList[j].warrantyTime = warranty+"年";
                //   }else {
                //     this.deviceList[j].warrantyStatus = 0;
                //     this.deviceList[j].warrantyTime = warranty+"年";
                //   }
                // }
              }
            }
            if (this.submittedOfferDevice != null) {
              for (var k = 0; k < this.submittedOfferDevice.length; k++) {
                if (this.submittedOfferDevice[k].imei == deviceLifeCycleList[i].imei) {
                  if (warranty == 9) {
                    this.deviceList[j].warrantyStatus = 9;
                    this.deviceList[j].warrantyTime = this.$t('saleAdmin.unknown');
                  } else {
                    if (retDate < (mils * warranty)) {
                      this.submittedOfferDevice[k].warrantyStatus = 1;
                      this.submittedOfferDevice[k].warrantyTime = warranty + this.$t('saleAdmin.years');
                    } else {
                      this.submittedOfferDevice[k].warrantyStatus = 0;
                      this.submittedOfferDevice[k].warrantyTime = warranty + this.$t('saleAdmin.years');
                    }
                  }
                }
                // if(this.submittedOfferDevice[k].sn == deviceLifeCycleList[i].sn){
                //   if(retDate<(mils*warranty)){
                //     this.submittedOfferDevice[k].warrantyStatus = 1;
                //     this.submittedOfferDevice[k].warrantyTime = warranty+"年";
                //   }else {
                //     this.submittedOfferDevice[k].warrantyStatus = 0;
                //     this.submittedOfferDevice[k].warrantyTime = warranty+"年";
                //   }
                // }
              }
            }
          }
          // var a = Utils.insertStr(Utils.insertStr("20201010",4,"-"),7,"-")
          // console.log(new Date(a.replace(/-/,"/")).getTime());
          //获取寄回快递详情
          if (this.saleOrder.receiveNum != null) {
            API.getExpressInfo({
              expressCode: this.saleOrder.receiveExpressCode,
              expressNum: this.saleOrder.receiveNum
            }).then(res => {
              console.log(res);
              if (res.code == 200) {
                this.receiveExpressInfo = res.data
              }
            })
          }
        }
      })
    },
    // downloadExcel(){
    //   window.location = this.saleOffer.s3url;
    // },
    openHistory(imei, sn) {
      this.HisSearch = {
        imei: imei,
        sn: sn
      };
      this.current = {
        pageSize: 10,
        page: 1,
        totalSize: 0
      };
      this.tableData = [];
      this.getHistory();
      this.HisListFlag = true;
      this.tableLoading = true;
    },
    openDeviceError(device) {
      this.deviceErrorModel = device;
      this.deviceErrorDlgFLg = true;
    },
    getHistory() {
      API.getHisList({
        currentPage: this.current.page,
        pageSize: this.current.pageSize,
        start: 0,
        data: this.HisSearch
      }).then(res => {
        if (res.code == 200) {
          console.log(res);
          this.tableData = res.data;
          this.current.page = res.data.currentPage;
          this.current.totalSize = res.data.total;
          this.tableLoading = false;
        } else {
          this.$toast.error(res.message);
        }
      })
    },
    onSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.updateLoading = true;
          this.updateOrder.id = this.currentId;
          if (this.saleOrder.status == -1) {
            if (this.updateOrder.status != -1) {
              this.updateOrder.remark = null;
            }
          }
          API.update(
            this.updateOrder
          ).then(res => {
            if (res.code == 200) {
              this.getOrderDesc();
              this.$toast.success(res.message);
              this.$refs['form'].clearValidate();
            } else {
              this.$toast.error(res.message);
            }
            this.updateLoading = false;
          });
        }
      });
    },
    offerSubmit() {
      this.updateLoading = true;
      if (this.offerDevice.length <= 0) {
        this.$toast.error(this.$t('saleAdmin.PleaseSelectTheQuotedDevice'));
        this.updateLoading = false;
        return
      }
      if (this.isFile == false) {
        this.$toast.error(this.$t('saleAdmin.QuotationNotUploaded'));
        this.updateLoading = false;
        return
      }
      console.log(this.fileList);
      this.$refs.upload.submit();
    },
    changeFaultClass(pcode) {
      API_DICTIONARY.getOptionItem({
        pCode: pcode
      }).then(res => {
        this.classificationList = res;
      })
    },
    // 更新设备故障信息
    submitDeviceError() {
      this.$refs['devceErrorForm'].validate((valid) => {
        if (valid) {
          API.updateDeviceError(this.deviceErrorModel).then(res => {
            if (res.code == 200) {
              this.$toast.success(res.message);
              this.deviceErrorDlgFLg = false;
              this.getOrderDesc();
            } else {
              this.$toast.error(res.message);
            }
          });
        }
      });

    },
    //确认付款
    changePaymentStatus() {
      API.changePay({
        id: this.saleOffer.id,
        status: 2
      }).then(res => {
        if (res.code == 200) {
          this.getOrderDesc();
          this.$toast.success(res.message);
        }
      })
    },
    //上传成功后的回调函数
    uploadSuccess() {
      this.updateOrder.id = this.currentId;
      API.updateOffer({
        saleOrder: this.updateOrder,
        deviceList: this.offerDevice,
        offerExcel: this.offerExcelUrl
      }
      ).then(res => {
        if (res.code == 200) {
          this.getOrderDesc();
          this.$toast.success(res.message);
        } else {
          this.$toast.error(res.message);
        }
        this.updateLoading = false;
      });
    },
    //添加或删除需要报价的设备
    addOfferDevice(id) {
      var index = this.offerDevice.indexOf(id)
      if (index == -1) {
        //添加设备id
        this.offerDevice.push(id);
      } else {
        //去除设备id
        this.offerDevice.splice(index, 1);
      }
      console.log(this.offerDevice);
    },
    onFileExceed(files, fileList) {
      if (fileList.length == 1) {
        this.$toast.warning(this.$t('appVersion.warning'));
      }
    },
    uploadChange(file, fileList) {
      console.log(file)
      console.log(fileList)
      this.isFile = true;
    },
    handleRemove() {
      this.isFile = false;
      this.$refs.upload.clearFiles();
    },

    async Upload(file) {
      let res = await uploadTemp({ raw: file.file, name: file.file.name }, p => {
        this.showProgress = true
        this.progress = Math.floor(p * 100)
      });
      that.offerExcelUrl = res.url;
    },
  }
}
</script>
<style scoped>.item_cls {
  color: #898989;
  font-size: 14px;
}

.item_cls span {
  margin-left: 4px;
  color: #3d3d3d;
}</style>



// WEBPACK FOOTER //
// src/views/saleService/SaleDesc.vue